import { API_URL } from "../config";
import axios from "axios";
import { CBEWSL_SITE_CODE } from "../host";

export const getEarthquakeInformation = (callback) => {
  axios
    .get(
      `${API_URL}/api/analysis/get_earthquake_information/${CBEWSL_SITE_CODE}`
    )
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
